import { render, staticRenderFns } from "./PartnershipSection.vue?vue&type=template&id=06f01e1f&scoped=true"
import script from "./PartnershipSection.vue?vue&type=script&lang=js"
export * from "./PartnershipSection.vue?vue&type=script&lang=js"
import style0 from "./PartnershipSection.vue?vue&type=style&index=0&id=06f01e1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f01e1f",
  null
  
)

export default component.exports